import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';

export type ArchiveWalletConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  walletName: string;
};

export const ArchiveWalletConfirmDialog: React.FC<ArchiveWalletConfirmDialogProps> = ({
  onClose,
  onConfirm,
  loading,
  walletName,
}) => {
  return (
    <ConfirmDialog
      dialogTitle='Archive Wallet'
      onClose={onClose}
      open
      maxWidth='xs'
      confirmButtonText='Archive'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
        color: 'error',
      }}
    >
      {loading && <LinearProgress />}
      <Typography>
        {`Are you sure you would like to archive "${walletName}" from your program?`}
      </Typography>
    </ConfirmDialog>
  );
};
